import { Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { AuthenticationService } from '../../core/services/authentication.service';
import { EmittersService } from '../../core/utils/emitters.service';
import { Subject, takeUntil } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'app-inactivity-modal',
	templateUrl: './inactivity-modal.component.html',
	styleUrls: ['./inactivity-modal.component.scss'],
	imports: [TranslateModule]
})
export class InactivityModalComponent implements OnDestroy {
	private _emittersService = inject(EmittersService);
	private _authenticationService = inject(AuthenticationService);

	@ViewChild('dismiss') dismiss!: ElementRef;
	private destroy$ = new Subject<void>();
	timerValue!: number;
	intervalId: any;

	timer!: string;
	constructor() {
		this._emittersService.inactivityStartCount.pipe(takeUntil(this.destroy$)).subscribe(() => this._resetTimer());
	}

	restart(): void {
		clearInterval(this.intervalId);
		this._emittersService.inactivityRestartCount.emit();
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
		clearInterval(this.intervalId);
	}

	private _startTimer(): void {
		if (this.intervalId) return;
		this.timerValue = 60; // 1 minutos en segundos (1 * 60)
		this.intervalId = setInterval(() => {
			if (this.timerValue > 0) {
				const minutes = Math.floor(this.timerValue / 60); // Calculamos los minutos
				const seconds = this.timerValue % 60; // Calculamos los segundos
				this.timer = `${this._pad(minutes)}:${this._pad(seconds)}`; // Mostramos  formato minutos:segundos
				this.timerValue--;
			} else {
				clearInterval(this.intervalId); // Detenemos el temporizador cuando llega a 0
				this.intervalId = null;
				this.dismiss.nativeElement.click();
				this._authenticationService.signout();
			}
		}, 1000); // Intervalo de 1 segundo
	}

	private _resetTimer(): void {
		clearInterval(this.intervalId); // Limpiamos cualquier intervalo anterior
		this.intervalId = null;
		this._startTimer(); // Reiniciamos el temporizador
	}

	private _pad(value: number): string {
		return value < 10 ? '0' + value : value.toString();
	}
}
